import styled, { keyframes } from "styled-components";
import { media } from '@/styles/Qtheme.ts';
import { TabletCalVW } from '@utils/CalVW.tsx';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-3px);
  }
`;

export const OrderContainerSection = styled.div<{ theme: any }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  background: ${({theme}) => theme.itemBg};
  border-radius: 18px;
  border: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.1)'};
  box-shadow: 
    0 6px 24px rgba(0, 0, 0, 0.11),
    0 2px 6px rgba(0, 0, 0, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(15px);
  position: relative;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: ${fadeInUp} 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    /* width: 100%; */
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(248, 121, 67, 0.04) 0%,
      rgba(255, 76, 0, 0.02) 40%,
      transparent 70%
    );
    transform: translate(-50%, -50%);
    pointer-events: none;
    animation: ${floatAnimation} 6s ease-in-out infinite;
  }

  &:hover {
    transform: translateY(-3px) scale(1.005);
    box-shadow: 
      0 12px 40px rgba(248, 121, 67, 0.2),
      0 6px 12px rgba(255, 76, 0, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.18),
      0 0 0 1px rgba(248, 121, 67, 0.12),
      0 0 15px rgba(255, 76, 0, 0.08);
  }

  @media ${media.desktop} {
    width: ${TabletCalVW(900)};
  }

  @media ${media.mobile} {
    border-radius: 14px;
    
    &:hover {
      transform: translateY(-2px) scale(1.002);
    }
  }
  
  .ant-card {
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    
    .ant-card-head {
      background: linear-gradient(
        135deg,
        ${({theme}) => theme.itemBg || '#ffffff'} 0%,
        ${({theme}) => theme.COLORS.primary || '#f87943'}08 100%
      );
      border-bottom: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.1)'};
      padding: 20px 24px;
      
      .ant-card-head-title {
        font-weight: 600;
        font-size: 18px;
      }
    }
    
    .ant-card-body {
      padding: 0;
      background: transparent;
    }
  }
  
  .ant-table-wrapper {
    .ant-table {
      background: transparent !important;
      
      .ant-table-thead > tr > th {
        background: linear-gradient(
          135deg,
          ${({theme}) => theme.itemBg || '#ffffff'} 0%,
          ${({theme}) => theme.COLORS.primary || '#f87943'}05 100%
        );
        border-bottom: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.1)'};
        color: ${({theme}) => theme.COLORS.textw || '#ffffff'};
        font-weight: 600;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        padding: 16px 12px;
      }
      
      .ant-table-tbody > tr {
        background: transparent !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border-bottom: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.05)'};
        
        &:hover {
          background: linear-gradient(
            135deg,
            ${({theme}) => theme.itemBg || '#ffffff'} 0%,
            ${({theme}) => theme.COLORS.primary || '#f87943'}05 100%
          ) !important;
        }
        
        > td {
          border-bottom: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.05)'};
          padding: 16px 12px;
          font-size: 14px;
          font-weight: 500;
          
          .ant-tag {
            border-radius: 12px;
            font-weight: 600;
            padding: 4px 12px;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.3px;
            border: none;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            transition: all 0.2s ease;
            
            &:hover {
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }
          }
        }
      }
      
      .ant-table-tbody > tr:last-child > td {
        border-bottom: none;
      }
    }
  }
  
  .custom-select-no-radius {
    border-radius: 8px !important;
    border: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.2)'} !important;
    background: ${({theme}) => theme.itemBg || '#ffffff'} !important;
    transition: all 0.3s ease !important;
    
    &:hover {
      border-color: ${({theme}) => theme.COLORS.primary || '#f87943'} !important;
      box-shadow: 0 2px 8px rgba(248, 121, 67, 0.2) !important;
    }
    
    &:focus, &.ant-select-focused {
      border-color: ${({theme}) => theme.COLORS.primary || '#f87943'} !important;
      box-shadow: 0 0 0 2px rgba(248, 121, 67, 0.2) !important;
    }
  }
  
  .ant-btn {
    border-radius: 8px;
    border: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.2)'};
    background: ${({theme}) => theme.itemBg || '#ffffff'};
    color: ${({theme}) => theme.COLORS.textw || '#ffffff'};
    font-weight: 500;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: ${({theme}) => theme.COLORS.primary || '#f87943'};
      background: ${({theme}) => theme.COLORS.primary || '#f87943'};
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(248, 121, 67, 0.3);
    }
  }
`;
